const CheckPosition = (htmlElem) => {
  const checkPositionX = () => {
    if (htmlElem.x <= 130) {
      return htmlElem.left + window?.scrollX + 130
    } else {
      return htmlElem.left + window?.scrollX
    }
  }
  const checkPositionY = () => {
    if (
      htmlElem.bottom + 150 <=
        (window?.innerHeight || document.documentElement.clientHeight) &&
      htmlElem.right <=
        (window?.innerWidth || document.documentElement.clientWidth)
    ) {
      return htmlElem.top + window?.scrollY
    } else {
      return htmlElem.top + window?.scrollY - 130
    }
  }
  return [checkPositionX(), checkPositionY()]
}

export default CheckPosition
